import { useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../app/i18n';
import cms from '../../../app/api/cms';

const SubmisionStatusModal = ({ submissionDataID }) => {
  const [submissionStatusModalOpen, setSubmissionStatusModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onClickHandler = async () => {
    let formData = new FormData();

    formData.append('status', 'reviewed');

    await cms
      .WebSubmissionChangeStatus(submissionDataID, formData)
      .then(function (response) {
        if (response.data.data !== undefined) {
          window.location.reload();
        }
      })
      .catch(function (error) {
        if (error.response.data.error !== undefined) {
          setErrorMessage(i18n.t(`formErrors.${error.response.data.error}`));
        }
      });
  };

  const onCancelHandler = () => {
    setSubmissionStatusModalOpen(false);
  };

  function assignArchiveModal() {
    return (
      <Modal
        className='delete-user-model'
        centered={true}
        isOpen={submissionStatusModalOpen}
        toggle={onCancelHandler}
      >
        <ModalHeader charcode='Y' toggle={() => setSubmissionStatusModalOpen(false)}></ModalHeader>
        <ModalBody>
          <p>{errorMessage}</p>
          <h6>Ar norite pakeisti užklausos statusą į peržiūrėta?</h6>
        </ModalBody>
        <ModalFooter className='d-flex justify-content-between'>
          <button onClick={onClickHandler} className='cancel-user-deletion'>
            Patvirtinti
          </button>
          <button className='confirm-user-deletion' onClick={onCancelHandler}>
            {i18n.t('asignMeModal.decline')}
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  return (
    <>
      {assignArchiveModal()}
      <button onClick={() => setSubmissionStatusModalOpen(true)} className='assign-me-btn'>
        Užklausa peržiūrėta
      </button>
    </>
  );
};

export default SubmisionStatusModal;
